import React, { Component } from "react";
import { connect } from "react-redux";
import { isNullOrUndefined } from "util";
import Tooltip from "@material-ui/core/Tooltip";
import { ViewportContext } from "../beta/utils/hooks/viewportProvider";
import { setUserSettingApiRequest } from "api/userSettings";

class Header extends Component {
    nestedDropdownListenerAdded = false;
    constructor(props) {
        super(props);

        this.state = {
            pageTitle: props.pageTitle,
            isInFullScreen: false,
            DarkMode: props.DarkMode,
            userInfo: props.userInfo,
        };

        this.renderNavLinks = this.renderNavLinks.bind(this);
        this.handleFullscreenMode = this.handleFullscreenMode.bind(this);
        this.onLogoutClick = this.onLogoutClick.bind(this);
        this.setToDarkMode = this.setToDarkMode.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            pageTitle: nextProps.pageTitle,
            DarkMode: nextProps.DarkMode,
            userInfo: nextProps.userInfo,
        });
    }

    componentDidMount() {
        document.onfullscreenchange = (event) => {
            this.fullscreenOnChange(event);
        };

        const dropdownToggle = document.querySelector(".dropdown-toggle");
        dropdownToggle?.addEventListener("click", function (event) {
            event.stopPropagation();
            event.stopImmediatePropagation();
            event.preventDefault();
            const dropdown = this.closest(".dropdown");
            if (dropdown) {
                dropdown.classList.toggle("open");
            }
        });

        document.addEventListener("click", function (event) {
            const dropdown = document.querySelector(".dropdown.open");
            if (
                dropdown &&
                event.target instanceof Node &&
                !dropdown.contains(event.target)
            ) {
                dropdown.classList.remove("open");
            }
        });

        if (this.state.userInfo) {
            this.addNestedDropdownListener();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            !prevState.userInfo &&
            this.state.userInfo &&
            !this.nestedDropdownListenerAdded
        ) {
            this.addNestedDropdownListener();
        }
    }

    addNestedDropdownListener() {
        document
            .querySelectorAll(
                ".dropdown-menu > .dropdown-submenu > a.nested-dropdown"
            )
            .forEach(function (element) {
                element.addEventListener("click", function (e) {
                    const ulElement = element.nextElementSibling;
                    if (ulElement && ulElement.tagName === "UL") {
                        ulElement.style.display =
                            ulElement.style.display === "none"
                                ? "block"
                                : "none";
                    }
                    e.preventDefault();
                    e.stopPropagation();
                });
            });
        this.nestedDropdownListenerAdded = true;
    }

    cancelFullScreen() {
        let el = document;
        let requestMethod =
            el.exitFullscreen ||
            el.webkitExitFullscreen ||
            el.mozExitFullscreen ||
            el.exitFullscreen;
        if (requestMethod) {
            requestMethod.call(el);
        } else if (typeof window.ActiveXObject !== "undefined") {
            // Older IE.
            // eslint-disable-next-line no-undef
            let wscript = new ActiveXObject("WScript.Shell");
            if (wscript !== null) {
                wscript.SendKeys("{F11}");
            }
        }
        this.setState({ isInFullScreen: false }, () => {
            // resize charts
            setTimeout(() => {
                let resizeEvent = window.document.createEvent("UIEvents");
                resizeEvent.initUIEvent("resize", true, false, window, 0);
                window.dispatchEvent(resizeEvent);
            }, 1000);
        });
    }

    requestFullScreen() {
        let el = document.body;
        let requestMethod =
            el.requestFullscreen ||
            el.webkitRequestFullscreen ||
            el.mozRequestFullscreen ||
            el.msRequestFullscreen;
        if (requestMethod) {
            requestMethod.call(el);
        } else if (typeof window.ActiveXObject !== "undefined") {
            // Older IE.
            // eslint-disable-next-line no-undef
            let wscript = new ActiveXObject("WScript.Shell");
            if (wscript !== null) {
                wscript.SendKeys("{F11}");
            }
        }
        this.setState({ isInFullScreen: true }, () => {
            // resize charts
            setTimeout(() => {
                let resizeEvent = window.document.createEvent("UIEvents");
                resizeEvent.initUIEvent("resize", true, false, window, 0);
                window.dispatchEvent(resizeEvent);
            }, 50);
        });
    }

    handleFullscreenMode() {
        if (!this.state.isInFullScreen) {
            this.requestFullScreen();
        } else {
            this.cancelFullScreen();
        }
    }

    fullscreenOnChange(event) {
        let elem = event.target;
        let isFullscreen = document.fullscreenElement === elem;

        this.setState({ isInFullScreen: isFullscreen });
    }

    sidenavToggleHandler() {
        // eslint-disable-next-line no-undef
        $("#lm-sidenav").toggleClass("lm-sidenav-hidden");
    }

    onLogoutClick(e) {
        e.preventDefault();
        sessionStorage.clear();
        document.getElementById("logoutForm").submit();
    }

    setToDarkMode(setDark) {
        const themeValue = setDark ? "dark" : "light";
        localStorage.setItem("color-theme", themeValue);
        // dispatchEvent(eventsToDispatch.HOST_THEME_CHANGED, {
        //     theme: setDark ? "dark" : "light",
        // });
        setUserSettingApiRequest({
            settingName: "DARK_MODE",
            settingValue: setDark,
        });
        this.setState({ DarkMode: setDark });
        document
            .getElementById("main-view")
            .classList.toggle("theme-light", !setDark);
        document
            .getElementById("main-view")
            .classList.toggle("theme-dark", setDark);
        // this.props.changeThemeActionCreator(setDark);
    }

    renderNavLinks() {
        const { printMode } = this.props;
        const { userInfo } = this.state;
        const { lqmAppInfo: { version } = {} } = window;

        if (printMode || isNullOrUndefined(userInfo)) {
            return null;
        }

        const icon = `fal fa-${
            this.state.isInFullScreen ? "compress-alt" : "expand-alt"
        }`;

        return (
            <form
                method="post"
                id="logoutForm"
                action="/Account/Logout"
                className="navbar-right"
            >
                <div className="dropdown">
                    <div
                        href="#"
                        data-toggle="dropdown"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                        className="dropdown-toggle navbar-right-btn"
                    >
                        <i className="fal fa-user"></i>

                        {/* <span> {userInfo.firstName && userInfo.lastName ? `${userInfo.firstName} ${userInfo.lastName}` : userInfo.email}</span> */}
                        <span className="user-info-label">
                            <span className="username-label no-margin">
                                <Tooltip
                                    title={
                                        userInfo?.isBicLive
                                            ? "Live BIC Account"
                                            : "Test/UAT BIC Account"
                                    }
                                >
                                    <span className="no-margin">
                                        {userInfo.username}
                                    </span>
                                </Tooltip>
                                <Tooltip
                                    title={
                                        userInfo?.isBicLive
                                            ? "Live BIC Account"
                                            : "Test/UAT BIC Account"
                                    }
                                >
                                    <small
                                        className={`bic-info-label ${
                                            userInfo?.isBicLive
                                                ? "live"
                                                : "not-live"
                                        }`}
                                    >
                                        {userInfo?.bic}
                                    </small>
                                </Tooltip>
                            </span>
                            <i className="fal fa-chevron-down m-l"></i>
                        </span>
                    </div>
                    <ul className="dropdown-menu">
                        {(userInfo?.roles?.includes("TCAAdmin") ||
                            userInfo?.roles?.includes("LMAdminSuperUser") ||
                            userInfo?.roles?.includes("MADAdmin")) && (
                            <li>
                                <a href="/app#/utils/subscriptions">
                                    Subscriptions In Use
                                </a>
                            </li>
                        )}
                        <li>
                            <a href="/app#/settings">Settings</a>
                        </li>
                        <li>
                            <a href="/app#/DataManager/DataUploadedHistory">
                                Data Manager
                            </a>
                        </li>
                        <li>
                            <a href="/" onClick={this.onLogoutClick}>
                                Log out
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="dropdown">
                    <div
                        href="#"
                        data-toggle="dropdown"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                        className="dropdown-toggle navbar-right-btn"
                    >
                        <i className="fal fa-archive"></i>
                    </div>
                    <ul className="dropdown-menu">
                        <li>
                            <a href="/Account/Download">Software Downloads</a>
                        </li>
                        <li>
                            <a href="/app#/settings/productresources">
                                Product Resources
                            </a>
                        </li>
                        <li>
                            <a href="/app#/settings/releasenotes">
                                Release Notes
                            </a>
                        </li>
                        <li>
                            <a href="/app#/settings/whatscomingup">
                                What's Coming Up
                            </a>
                        </li>
                        {/* <li className="dropdown-submenu">
                            <a className="nested-dropdown">
                                Product Information
                                <i className="fal fa-chevron-down m-l-sm"></i>
                            </a>
                            <ul className="dropdown-menu-right">
                                <li>
                                    <a href="/app#/settings/productresources">
                                        Product Resources
                                    </a>
                                </li>
                                <li>
                                    <a href="/app#/settings/releasenotes">
                                        Release Notes
                                    </a>
                                </li>
                            </ul>
                        </li> */}
                        <li className="dropdown-submenu">
                            <a className="nested-dropdown">
                                Data Definitions
                                <i className="fal fa-chevron-down m-l-sm"></i>
                            </a>
                            <ul className="dropdown-menu-right">
                                <li>
                                    <a href="/app#/utils/venues">
                                        Trading Venues
                                    </a>
                                </li>
                                <li>
                                    <a href="/AssetTypes/IndexAssetTypes">
                                        Asset Types
                                    </a>
                                </li>
                                <li>
                                    <a href="/app#/utils/fields">
                                        Field Definitions
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a href="/app#/utils/OutagesAndHolidays">
                                Outages/Holidays
                            </a>
                        </li>
                        <li role="separator" className="divider"></li>
                        <li>
                            <a href="/Account/ContactUs">Contact Us</a>
                        </li>
                        <li role="separator" className="divider"></li>
                        <li>
                            <a href="/Account/DownloadLatestReleaseNotes">
                                {version || "Release Notes"}
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="dropdown">
                    <div
                        href="#"
                        data-toggle="dropdown"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                        className="navbar-right-btn"
                    >
                        {this.state.DarkMode ? (
                            <Tooltip title="Switch to Light Mode">
                                <i
                                    className="fas fa-sun"
                                    onClick={() => this.setToDarkMode(false)}
                                ></i>
                            </Tooltip>
                        ) : (
                            <Tooltip title="Switch to Dark Mode">
                                <i
                                    className="fas fa-moon"
                                    onClick={() => this.setToDarkMode(true)}
                                ></i>
                            </Tooltip>
                        )}
                    </div>
                </div>
                <div
                    className="navbar-right-btn full-screen-btn"
                    onClick={this.handleFullscreenMode}
                >
                    <i className={icon}></i>
                </div>
                <input
                    name="XSRF-TOKEN"
                    type="hidden"
                    value="CfDJ8ACDDardCKhAindeTxR4keQ6WqytRrH4H1Gk8AzdoToUGpvpjBWlpa7LpVoWjw8MTCyYlBChrRixZen2ze5Rg_1U812Zc_YjU2sEqhrX75aeWbeh58nno9LbSkkyRRt9bLtgxfxa8dzNGlwpO8keIlBHen3w_fXbi6EBz-jjlD6xniYLqtlN0feaXEfG3T-MXA"
                />
            </form>
        );
    }

    getLogo = (breakpoint) =>
        breakpoint == "xs"
            ? "/images/ISSLogo.svg"
            : "/images/ISSLiquidMetrixLogo.png";

    render() {
        return (
            <ViewportContext.Consumer>
                {(view) => (
                    <nav role="navigation" className="lm-navbar">
                        <div
                            className="sidebar-toggle"
                            onClick={this.sidenavToggleHandler.bind(this)}
                        >
                            <i className="fal fa-bars"></i>
                        </div>
                        <a href="/" className="logo">
                            <img src={this.getLogo(view.currentBreakpoint)} />
                        </a>
                        {this.renderNavLinks()}
                    </nav>
                )}
            </ViewportContext.Consumer>
        );
    }
}

export default Header;
